import React, {Component} from 'react';
import './PaymentManagementDashboard.css';
import {inject, observer} from 'mobx-react';
import SubHeader from "../SubHeader";
import PaymentManagementCard from "./PaymentManagementCard";

@inject('commonStore', 'translationsStore')
@observer
export default class PaymentManagementDashboard extends Component {

  render () {
    const { translationsStore } = this.props;

    return (
      <div className="PaymentManagementDashboard">
        <SubHeader className="PaymentSubHeader">
          <div style={{margin: '0px auto 50px auto', color: 'white', fontSize: 36}}>{ translationsStore.translate('paymentManagement.title') }</div>
        </SubHeader>
        <div className={'PaymentManagementDashboardContainer'}>
          <div className={'paymentManagementDashboardBody'}>
            <PaymentManagementCard />
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App/PaymentManagementDashboard/PaymentManagementDashboard.js